import React, { PropsWithChildren } from 'react';
import { Box, Card, CardActionArea, CardContent, Typography } from '@material-ui/core';
import styles from './SGSCard.module.scss';
import classnames from 'classnames';
import SGSCardFooter from './SGSCardFooter';
import { useTranslation } from 'react-i18next';
import { SGSCardHeader } from 'components';

type Props = {
    color?: 'default' | 'info' | 'success' | 'warning' | 'danger' | 'primary' | 'secondary' | 'dark';
    widgetColor?: 'primary' | 'secondary' | 'midblue' | 'danger' | 'dark';
    size?: 'sm' | 'md';
    title?: string;
    noTitleTranslation?: boolean;
    image?: string;
    footer?: JSX.Element;
    onClick?(): void;
    variant?: 'elevation' | 'outlined';
    className?: string;
    widgetTitle?: string;
    contentStyle?: string;
    shadow?: boolean;
};

const SGSCard: React.FC<PropsWithChildren<Props>> = ({
    color = 'default',
    size = 'md',
    children,
    title,
    noTitleTranslation,
    image,
    onClick,
    footer,
    variant = 'outlined',
    className,
    widgetTitle,
    widgetColor = 'primary',
    contentStyle = '',
    shadow,
    ...props
}) => {
    const { t } = useTranslation();
    const Wrapper = onClick ? CardActionArea : React.Fragment;
    const wrapperProps = onClick ? { onClick } : {};
    return (
        <Card {...props} classes={{ root: `${styles.root} ${styles['card-' + color]}` }} variant={variant} className={classnames(styles['card-' + size], className) + ' ' + classnames({ shadow })}>
            {widgetTitle && <SGSCardHeader color={widgetColor} title={widgetTitle} />}
            <Wrapper {...wrapperProps}>
                {image && (
                    <Box display="flex" justifyContent="center">
                        <img className={styles.media} src={image} alt={title} />
                    </Box>
                )}
                {title && (
                    <Typography variant="h2" className={styles.title}>
                        {noTitleTranslation ? title : t(title)}
                    </Typography>
                )}
                <CardContent className={contentStyle}>{children}</CardContent>
            </Wrapper>
            {footer && <SGSCardFooter color={color}>{footer}</SGSCardFooter>}
        </Card>
    );
};

export default SGSCard;
